import { createHooks } from '@wordpress/hooks';

export const hooks = createHooks();
